module.exports = __webpack_public_path__ + "img/ARRASTAR.7958dd02.svg";